
import { takeEvery, put, call } from "redux-saga/effects"
import {
    logout,
    setWebsites,
    setAuthUser,
    setPageStatus,
    setDynamicAssetsData,
    setMfaRequired,
    setOtpToken,
    setOtpEmail,
} from "../actions"
import TYPES from "../types"
import {
    fetchWrapperByFilterApiCall,
    login,
    saveRouteApiCall,
    verifyOtpApi,
    resendOtpApi,
} from "../general/api"
import { FetchHelper } from "../../utils/fetchHelper"

const fetchAssets = async (authToken) => {
    try {
        const resp = await FetchHelper.get(
            "api/v1/user/access-review", // url
        )
        if (resp?.data?.status) {
            localStorage.setItem(
                "is_user_access_review_pending",
                JSON.stringify(resp?.data?.data?.is_user_access_review_pending),
            )
            localStorage.setItem(
                "is_user_access_review_pending_btn",
                JSON.stringify(resp?.data?.data?.is_user_access_review_pending),
            )
            localStorage.setItem("review_message", resp?.data?.message)
        }
    } catch (err) {
        console.log("err--->", err)
    }
}

function* loginUser(action) {
    try {
        yield put(setPageStatus(true))

        const data = yield call(login, action) // Ensure that action.payload contains the necessary data for the login API call

        yield put(setPageStatus(false))
        if (data?.trigger_mfa) {
            yield put(setOtpToken(data.otp_token))
            yield put(setOtpEmail(action.payload.email))
            yield put(setMfaRequired(true))
        } else {
            localStorage.setItem("token", data.auth_token)
            yield put(setAuthUser(data.user_details))
            yield put(setWebsites(data.fleet_manager_data))
            yield put(setMfaRequired(false))
            yield put(setOtpToken(""))
            yield put(setOtpEmail(""))
        }
        fetchAssets(data?.auth_token)
    } catch (error) {
        yield put(setPageStatus(false))
        console.error(error)
    }
}

function* verifyOtp(action) {
    try {
        yield put(setPageStatus(true))

        const response = yield call(verifyOtpApi, action)

        yield put(setPageStatus(false))

        if (response.status) {
            localStorage.setItem("token", response.data.auth_token)
            yield put(setAuthUser(response.data.user_details))
            yield put(setWebsites(response.data.fleet_manager_data))
            yield put(setMfaRequired(false))
            yield put(setOtpToken(""))
            yield put(setOtpEmail(""))
            fetchAssets(data?.auth_token)
        }
    } catch (error) {
        yield put(setPageStatus(false))
        console.error(error)
    }
}

function* resendOtp(action) {
    try {
        const response = yield call(resendOtpApi, action)

        if (response.status) {
            yield put(setOtpToken(response.data.otp_token))
            yield put(setMfaRequired(true))
        }
    } catch (error) {
        console.error(error)
    }
}

function* logoutUser() {
    yield put(logout())
    localStorage.clear()
    sessionStorage.clear()
    localStorage.removeItem("app")
    localStorage.removeItem("token")
    window.location.href = "/"
}

function* saveRoute(action) {
    const data = yield call(saveRouteApiCall, action)
    if (action.promise) {
        action.promise.resolve(data)
    }
}

function* fetchWrapperByFilter(action) {
    const data = yield call(fetchWrapperByFilterApiCall, action)
    yield put(setDynamicAssetsData(data))
}

function* UserSaga() {
    yield takeEvery(TYPES.AUTHENTICATE_USER, loginUser)
    yield takeEvery(TYPES.SAVE_ROUTE, saveRoute)
    yield takeEvery(TYPES.LOGOUT_USER, logoutUser)
    yield takeEvery(TYPES.FETCH_ASSETS_BY_FILTER, fetchWrapperByFilter)
    yield takeEvery(TYPES.VERIFY_OTP_REQUEST, verifyOtp)
    yield takeEvery(TYPES.RESEND_OTP_REQUEST, resendOtp)
}

export default UserSaga
